import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Support from '@frontend/containers/Support';

var SupportPage = function SupportPage(_ref) {
  var platforms = _ref.platforms;
  return _jsx(Support, {
    platforms: platforms
  });
};

export var __N_SSG = true;
export default SupportPage;